module.exports = __webpack_public_path__ + "static/media/kitchenmarket_thumb.81208054.webp";